import { storage } from './index';

export const uploadFile = async (file: File | Blob): Promise<string> => {
  const fileRef = storage.ref().child(`file-${new Date().getTime()}`);
  const uploadedFileRef = await fileRef.put(file);
  return uploadedFileRef.ref.getDownloadURL();
};